import {Component, OnInit, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import { MatSort} from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {ReportsSubscriptionsService} from './reports-subscriptions.service';
import {ReportSubscriptionDialogComponent} from './dialogs/report-subscription-dialog/report-subscription-dialog.component';
import {ReportSubscriptionStaffDialogComponent} from './dialogs/report-subscription-staff-dialog/report-subscription-staff-dialog.component';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {SubcategoryService} from '../services/subcategory.service';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {FileService} from '../services/file.service';


@Component({
  selector: 'app-reports-subscriptions',
  templateUrl: './reports-subscriptions.component.html',
  styleUrls: [ './reports-subscriptions.component.scss' ]
})
export class ReportsSubscriptionsComponent implements OnInit {

  @ViewChild('sortMember', {static: true}) sortMember = new MatSort();
  @ViewChild('sortStaff', {static: true}) sortStaff = new MatSort();

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'date', 'name', 'validEmail', 'email', 'validCPF', 'cpf', 'gender', 'value', 'docStatus', 'export' ];

  public dataSourceStaff: MatTableDataSource<any>
  public displayedColumnsStaff: string[] = [ 'photoURL', 'name', 'validEmail', 'email', 'validCPF', 'cpf', 'gender', 'validText', 'subscription', 'export' ];

  public allProductEvents: any[] = []

  public allProducts: any[] = []
  public allDocuments: any[] = []

  public arrayOrders: any[] = []

  public categories: any[] = []

  public count: number;
  public countStaff: number;

  public selectedProduct: any;

  public waiting: any;

  public arrayMembersStaff: any[] = []
  public arrayMembers: any[] = []

  public product_name: string;
  public product_id: string;

  public byTopicFlag: boolean = false;
  public arrayConters: any = [] = [];


  constructor (
    private db: AngularFirestore,
    private snackBar: SnackBarIconService,
    private dialog: MatDialog,
    private _reportsSubscriptionsService: ReportsSubscriptionsService,
    private _subcategoryService: SubcategoryService,
    private _spinnerService: SpinnerService,
    private _fileService: FileService,
  ) {

    //this.categories = this._reportsSubscriptionsService.loadCategories()

    this._reportsSubscriptionsService.loadCategories()
      .subscribe((result) => {
        this.categories = []

        result.forEach((item) => {
          this.categories.push({
            'id': item.id,
            'name': item.data().name
          })
        })

        this.loadProducts()
        this.loadMembersStaff()
        this.loadDocuments()

      })

  }

  ngOnInit () {
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  _loadCategories () {
    this._subcategoryService
      .load()
      .subscribe((result) => {
        this.categories = []

        result.forEach((item) => {
          if (item.data().front_desk) {
            this.categories.push({
              'id': item.id,
              'name': item.data().name
            })
          }
        })

        console.log(JSON.stringify(this.categories))
      })



  }

  loadProducts () {
    //this._reportsSubscriptionsService.loadProducts()
    this._reportsSubscriptionsService.selectAllProductsNoAnnuities()
      .subscribe((result) => {
        this.allProducts = []
        result.forEach((item) => {
          this.allProducts.push({
            'id': item.payload.doc.id,
            'name': item.payload.doc.data().name
          })
        })
      })
  }

  refresh () {
    this.loadProducts()
    this.loadMembersStaff()
    this.loadDocuments()

    this.selectProductChange(this.product_id)
  }

  selectProductChange (product_id) {
    //  console.log("product_id: " + product_id)

    let prod = this.allProducts.find((e) => {
      return e.id == product_id
    })

    if (prod.id == 'CBCdc3adRHJc3vwDsJUr' || prod.id == 'K9AtkYDWqTaT2YXyfK8S') {
      //  console.log('é hands-on')
      this.byTopicFlag = true;
    } else {
      this.byTopicFlag = false;
    }

    this.getOrders(product_id)
    this.getAllProductEvents(product_id)

    this.product_name = prod.name
    this.product_id = prod.id
  }

  getOrders (product_id: string) {

    this.waiting = this._spinnerService.show()

    this.count = 0;

    if (this.dataSource)
      this.dataSource.data = [];

    this._reportsSubscriptionsService.getOrders(product_id)
      .subscribe((result) => {
        this.count = 0;
        this.countStaff = 0;
        this.arrayConters = [];

        this.arrayOrders = []

        result.forEach(element => {

          let cpf = ""
          if (element.payload.doc.data().member_cpf) {
            cpf = element.payload.doc.data().member_cpf;
            cpf = cpf.split('.').join('');
            cpf = cpf.split(',').join('');
            cpf = cpf.split(';').join('');
            cpf = cpf.split('-').join('');
            cpf = cpf.split(':').join('');
            cpf = cpf.split(' ').join('');
          }

          let email = ""
          if (element.payload.doc.data().member_email) {
            email = element.payload.doc.data().member_email
            email = email.trim();
            email = email.toLowerCase();
          }

          let isValidCPF: boolean = this._reportsSubscriptionsService.isValidCPF(cpf);
          let isValidEmail: boolean = this._reportsSubscriptionsService.isValidEmail(email);

          this.count = this.count + 1;

          let docStatus
          let doc = this.allDocuments.find((e) => {
            return e.member_id == element.payload.doc.data().member_id &&
              e.product_id == element.payload.doc.data().product_id
          })


          // Verififa se tem documentos pendentes
          if (doc) {
            //  console.log(JSON.stringify(doc))
            docStatus = doc.docStatus
          } else {
            docStatus = '-'
          }

          let nonMemberCategory: any = {};

          if (element.payload.doc.data().nonMemberCategory_id) {
            nonMemberCategory = this.categories.find((e) => {
              return e.id == element.payload.doc.data().nonMemberCategory_id
            })

          }

          const entity = this.arrayMembers.find((e)=>{
            return e.id === element.payload.doc.data().member_id
          })

          let gender = "";
          if(entity){
            gender = entity.sex ? entity.sex : ''
          }
          //console.log('gender: ' + gender)

          this.arrayOrders.push({
            'id': element.payload.doc.id,
            'date': element.payload.doc.data().date,
            'name': element.payload.doc.data().member_name,
            'member_id': element.payload.doc.data().member_id,
            'email': element.payload.doc.data().member_email ? element.payload.doc.data().member_email.trim() : "",
            'cpf': cpf.trim(),
            'validCPF': isValidCPF,
            'validEmail': isValidEmail,
            'value': element.payload.doc.data().total,
            'category': element.payload.doc.data().category_name,
            'nonMemberCategory_id': element.payload.doc.data().nonMemberCategory_id ? element.payload.doc.data().nonMemberCategory_id : '',
            'nonMemberCategory_name': nonMemberCategory ? nonMemberCategory.name : "",
            'topic_id': element.payload.doc.data().topic_id,
            'topic_name': element.payload.doc.data().topic_name,
            'docStatus': docStatus,
            'gender': gender
          })

          // se vaga for cntrolada por tópico
          if (this.byTopicFlag) {
            let exist = this.arrayConters.find((e) => {
              return e.topic_id == element.payload.doc.data().topic_id
            })

            if (exist) {
              exist.topic_count++
            } else {
              this.arrayConters.push({
                'topic_id': element.payload.doc.data().topic_id,
                'topic_name': element.payload.doc.data().topic_name,
                'topic_count': 1
              })
            }
          }

        });


        this.arrayConters.sort(this.compareTopics)
        // console.log("this.arrayConters: " + JSON.stringify(this.arrayConters))

        this.dataSource = new MatTableDataSource(this.arrayOrders);
        this.dataSource.sort = this.sortMember;

        this.waiting.close();

      })
  }

  compareTopics (a: any, b: any) {

    const pa = String(a.topic_name)
    const pb = String(b.topic_name)

    if (pa > pb) return 1;
    if (pb > pa) return -1;

    return 0;
  }

  openDialog (entity) {

    let dialogRef = this.dialog.open(ReportSubscriptionDialogComponent, {
      width: '600px',
      height: '500px',
      panelClass: 'custom-dialog-container',
      data: entity
    });

    dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: FormGroup = response[ 1 ];

        let formData: any = form.getRawValue();

        if (actionType == 'update') {
          let entity: any = this.createEntity(formData);

          console.log("entity update: " + JSON.stringify(entity));

          this._reportsSubscriptionsService.update(entity)
            .then(() => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success');
            })
            .catch((error) => {
              console.log("inscrição update error: " + JSON.stringify(error))
            })

        }

      });
  }

  openDialogStaff (entity) {

    let dialogRef = this.dialog.open(ReportSubscriptionStaffDialogComponent, {
      width: '700px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: {'entity': entity}
    });

    dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: FormGroup = response[ 1 ];

        let formData: any = form.getRawValue();

        if (actionType == 'update') {
          let entity: any = this.createEntityStaff(formData);

          //    console.log("entity updateStaff: " + JSON.stringify(entity));
          //    console.log("objectImage: " + this._reportsSubscriptionsService.objectImage);

          const entity_id = entity.id
          console.log("entity updateStaff: " + JSON.stringify(entity));

          this._reportsSubscriptionsService.updateStaff(entity)
            .then(() => {
              if (this._reportsSubscriptionsService.objectImage) {
                this._reportsSubscriptionsService.uploadImage(this._reportsSubscriptionsService.objectImage, entity_id)
              }
              this.snackBar.openSnackBar("Sucesso!", '', 'success');
            })
            .catch((error) => {
              console.log("inscrição update error: " + JSON.stringify(error))
            })


        }

      });
  }

  createEntity (data: any): any {
    let entity: any = {};
    entity.id = data.id;
    entity.member_name = data.name;
    entity.member_email = data.email;
    entity.member_cpf = data.cpf;

    if (data.nonMemberCategory_id) {
      entity.nonMemberCategory_id = data.nonMemberCategory_id;
    }

    return entity;
  }

  createEntityStaff (data: any): any {
    let entity: any = {};
    entity.id = data.id;
    entity.name = data.name ? data.name : '';
    entity.email = data.email ? data.email : '';
    entity.cpf = data.cpf ? data.cpf : '';
    entity.text = data.text ? data.text : '';
    entity.image = data.image ? data.image : '';

    if (!entity.text) {
      delete entity.text
    }

    if (!entity.image) {
      delete entity.image
    }

    return entity;
  }


  exportToCsv () {

    let data: any[];

    let csvFile: any[] = []

    data = this.dataSource.data;
    csvFile.push("" + ";" + this.product_name + '\r\n')

    let csvHeader: string;


    if (this.byTopicFlag) {
      this.arrayConters.forEach(element => {
        csvFile.push(";" + element.topic_count + ';' + element.topic_name + '\r\n')
      });
    }

    csvHeader = "" + ";"
    csvHeader += 'Nome' + ';'

    if (this.byTopicFlag) {
      csvHeader += 'Módulo' + ';'
    }

    csvHeader += 'Email' + ';'
    csvHeader += 'Válido' + ';'
    csvHeader += 'CPF' + ';'
    csvHeader += 'Genero' + ';'
    csvHeader += 'Categoria' + ';'
    csvHeader += 'Valor' + ';'
    csvHeader += 'Docs' + '\r\n'

    csvFile.push(csvHeader)

    data.forEach((item) => {

      let csvLine: string;
      csvLine = "" + ";"

      csvLine += (item.name || '') + ";";

      if (this.byTopicFlag) {
        csvLine += (item.topic_name || '') + ";";
      }

      csvLine += (item.email || '') + ";";
      csvLine += (item.validCPF ? 'sim' : 'não') + ";";
      csvLine += (item.cpf || '') + ";";
      csvLine += (item.gender || '') + ";";
      csvLine += (item.category || '-') + ";";
      csvLine += (item.value || '0') + ";";
      csvLine += (item.docStatus || '-') + "\r\n";

      csvFile.push(csvLine)

    })

    var BOM = "\ufeff";
    let csvData = BOM + csvFile;

    var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});

    this._fileService.saveFile(blob, "inscritos_" + this.product_name + ".csv");

  }


  exportToCsvStaff () {

    let data: any[];

    let csvFile: any[] = []

    data = this.dataSourceStaff.data;
    csvFile.push("" + ";" + this.product_name + " - Staff" + '\r\n')

    let csvHeader: string;

    csvHeader = "" + ";"
    csvHeader += 'Nome' + ';'
    csvHeader += 'Categoria' + ';'
    csvHeader += 'Email' + ';'
    csvHeader += 'Válido' + ';'
    csvHeader += 'CPF' + ';'
    csvHeader += 'Genero' + ';'
    csvHeader += 'Celular' + ';'
    csvHeader += 'Curriculo' + ';'
    csvHeader += 'Inscrição' + '\r\n'

    csvFile.push(csvHeader)

    data.forEach((item) => {

      let csvLine: string;
      csvLine = "" + ";"

      csvLine += (item.name || '') + ";";
      csvLine += (item.subCategory.name || '') + ";";
      csvLine += (item.email || '') + ";";
      csvLine += (item.validCPF ? 'sim' : 'não') + ";";
      csvLine += (item.cpf || '') + ";";
      csvLine += (item.sex || '') + ";";
      csvLine += (item.cellPhone || '') + ";";
      csvLine += (item.validText ? 'sim' : 'não') + ";";
      csvLine += (item.hasSubscription ? 'sim' : 'não') + "\r\n";

      csvFile.push(csvLine)

    })

    var BOM = "\ufeff";
    let csvData = BOM + csvFile;

    var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});

    this._fileService.saveFile(blob, "staff_" + this.product_name + ".csv");

  }

  ///////////////////////////
  getAllProductEvents (product_id) {
    this._reportsSubscriptionsService.getProductItens(product_id)
      .subscribe((result) => {
        this.allProductEvents = []

        result.forEach((item) => {
          // console.log("getAllProductEvents event_id: " + item.data().event_id)
          this.allProductEvents.push({
            'id': item.data().event_id,
            'name': item.data().event_name
          })
        })
        //console.log("allProductEvents: " + JSON.stringify(this.allProductEvents))
        this.loadAgenda()
      })
  }

  loadAgenda () {
    let agenda: any[] = []
    let totalItens: number = this.allProductEvents.length
    let count: number = 0;

    //   console.log("totalItens: " + totalItens)

    this.allProductEvents.forEach((item) => {

      this._reportsSubscriptionsService.selectAgendaStaff(item.id)
        .subscribe((result) => {
          count++

          result.forEach((item) => {
            agenda.push(item.data())
          })

          if (count >= totalItens) {
            agenda.sort(this._reportsSubscriptionsService.compareNames)
            this.processAgenda(agenda)
          }
        })

    })

  }

  processAgenda (array) {
    let current_member_name: string = ""
    let item: any = {}
    let agenda: any[] = []

    array.forEach((a) => {

      if (current_member_name != a.member_name) {
        this.countStaff++
        current_member_name = a.member_name
        item = {}
        item.name = a.member_name
        item.id = a.member_id

        let m = this.arrayMembersStaff.find((e) => {
          return e.id == item.id
        })

        if (m) {
          item.email = m.email
          item.cellPhone = m.cellPhone
          item.text = m.text
          item.cpf = m.cpf
          item.sex = m.sex
          item.image = m.image
          item.subCategory = m.subCategory
        } else {
          item.email = ''
          item.cellPhone = ''
          item.text = ''
          item.cpf = ''
          item.sex = ''
          item.image = ''
          item.subCategory = {}
        }

        let order = this.arrayOrders.find((e) => {
          return e.member_id == item.id
        })

        if (order) {
          item.hasSubscription = true
        } else {
          item.hasSubscription = false
        }

        item.validCPF = this._reportsSubscriptionsService.isValidCPF(item.cpf)
        item.validEmail = this._reportsSubscriptionsService.isValidEmail(item.email)

        if (item.text) {
          item.validText = item.text.length > 30 ? true : false
        } else {
          item.validText = false
        }

        item.agenda = []
        agenda.push(item)

      }

      item.agenda.push({
        'event': a.event_name,
        'day': a.day_name,
        'activity': a.activity_name,
        'topic': a.topic_name,
      })

    })
    //   console.log("agenda: " + JSON.stringify(agenda))
    this.dataSourceStaff = new MatTableDataSource(agenda);
    this.dataSourceStaff.sort = this.sortStaff;
  }

  loadMembersStaff () {
    this._reportsSubscriptionsService.loadMembers()
      //this._reportsSubscriptionsService.loadMemberStaffs()
      .subscribe((result) => {
        this.arrayMembersStaff = []
        this.arrayMembers = []

        result.forEach((item) => {

          const isDeleted = item.payload.doc.data().deleted ? true : false

          if (!isDeleted) {

            this.arrayMembers.push({
              'id': item.payload.doc.id,
              'name': item.payload.doc.data().name,
              'sex': item.payload.doc.data().sex
            })

            const isStaff = item.payload.doc.data().staff ? true : false

            if (isStaff) {

              this.arrayMembersStaff.push({
                'id': item.payload.doc.id,
                'name': item.payload.doc.data().name,
                'email': item.payload.doc.data().email,
                'cellPhone': item.payload.doc.data().cellPhone,
                'cpf': item.payload.doc.data().cpf,
                'text': item.payload.doc.data().text,
                'image': item.payload.doc.data().image,
                'subCategory': item.payload.doc.data().subCategory,
                'sex': item.payload.doc.data().sex,
              })

            }

          }

        })

      })

  }

  loadDocuments () {

    this._reportsSubscriptionsService.loadDocuments()
      .subscribe((result) => {

        this.allDocuments = []

        result.forEach((item) => {
          let entity: any = {};
          entity.id = item.id;
          entity.sent = item.data().sent ? item.data().sent : false;
          entity.pending = item.data().pending ? item.data().pending : false;
          entity.approved = item.data().approved ? item.data().approved : false;
          entity.member_name = item.data().member_name;
          entity.member_id = item.data().member_id;
          entity.product_name = item.data().product_name;
          entity.product_id = item.data().product_id;
          let dt: any = item.data().date;
          entity.date = new Date(dt.seconds * 1000)
          entity.obs = item.data().obs;

          let docStatus: string;

          if (entity.pending && !entity.sent && !entity.approved) {
            docStatus = "Pend"
          }
          else if (!entity.pending && entity.sent && !entity.approved) {
            docStatus = "Env"
          }
          else if (entity.approved) {
            docStatus = "Apr"
          }

          entity.docStatus = docStatus;

          this.allDocuments.push(entity)
        })

        //  console.log("documents: " + JSON.stringify(this.allDocuments))
      })

  }

  insertDoc () {

    console.log("insertDoc")

    const product_id = 'K9AtkYDWqTaT2YXyfK8S' //RESCV • Curso de Residentes de Cardiovascular • 2022
    const member_id = '062gyxlCxousvX5khJCY'

    return this.db.collection<any>('sbccv_orders', ref => ref
      .where('product_id', '==', product_id)
      .where('member_id', '==', member_id))
      .get()
      .subscribe((result) => {
        result.forEach((item) => {

          //console.log(item.data().member_name)
          //console.log(JSON.stringify(item.data()))

          let pending_doc: any = item.data()
          pending_doc.pending = true

          //  console.log(JSON.stringify(pending_doc))

          this.insertPendingDoc(pending_doc)

        })
      })


  }

  insertPendingDoc (doc) {
    //  console.log(JSON.stringify(doc))
    return this.db.collection('sbccv_pendingdocs').add(Object.assign({}, doc))
      .then(() => {
        console.log("ok --------------")
      })
      .catch(() => {
        console.log("error")
      })

  }

}
